import { PopularOption } from '@/entities/map'
import { AdditionalOption, BasicOption } from '@/entities/room'
import { cn, useMultiScrollState } from '@/shared/lib'

import { OptionsInDefaultView } from './default'
import { OptionsInDialogView } from './dialog'
import { Filter, FilterType, useFilter } from '../../../model/filter'

type Props = {
  className?: string
}

export const Options = ({ className }: Props) => {
  const { target, registerScrollElement, scrollIntoView } =
    useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { popularOptions, basicOptions, additionalOptions },
    updateFilter,
  } = useFilter()

  const isSelected = (value: PopularOption | BasicOption | AdditionalOption) =>
    popularOptions.includes(value as PopularOption) ||
    basicOptions.includes(value as BasicOption) ||
    additionalOptions.includes(value as AdditionalOption)

  const optionsRef = (element: HTMLDivElement) => {
    if (element) {
      registerScrollElement(Filter.Options, element)
    }
  }

  const handleExpandButtonClick = () => {
    requestAnimationFrame(() => {
      scrollIntoView(Filter.Options, {
        behavior: 'smooth',
        block: 'start',
      })
    })
  }

  if (type === FilterType.Dialog) {
    return (
      <OptionsInDialogView
        type={type}
        ref={optionsRef}
        className={className}
        defaultExpanded={target === Filter.Options}
        selected={isSelected}
        onExpandClick={handleExpandButtonClick}
        onChange={updateFilter}
      />
    )
  }

  return (
    <OptionsInDefaultView
      ref={optionsRef}
      type={type}
      className={cn('pr-2', className)} // 디자인과 줄바꿈 맞추기 위해 여백 추가
      selected={isSelected}
      onChange={updateFilter}
    />
  )
}
